import React from 'react';
import { HeatmapCategory } from '../../types';

interface CategoryHeatmapProps {
  categories: HeatmapCategory[];
}

const statusColor = (status: string) => {
  switch (status) {
    case 'excellent': return { bar: 'bg-green-500', badge: 'bg-green-100 text-green-800' };
    case 'good': return { bar: 'bg-blue-500', badge: 'bg-blue-100 text-blue-800' };
    case 'needs_improvement': return { bar: 'bg-amber-500', badge: 'bg-amber-100 text-amber-800' };
    default: return { bar: 'bg-red-500', badge: 'bg-red-100 text-red-800' };
  }
};

const statusLabel = (status: string) => {
  switch (status) {
    case 'excellent': return '✅ Excellent';
    case 'good': return '👍 Good';
    case 'needs_improvement': return '⚠️ Needs Work';
    default: return '🔴 Critical';
  }
};

export const CategoryHeatmap: React.FC<CategoryHeatmapProps> = ({ categories }) => {
  return (
    <div className="space-y-3">
      {categories.map((cat) => {
        const colors = statusColor(cat.status);
        return (
          <div key={cat.category_id}>
            <div className="flex items-center justify-between mb-1">
              <div>
                <span className="text-sm font-medium text-gray-800">{cat.category_name}</span>
                <span className="ml-2 text-xs text-gray-400">(Weight: {cat.weight}%)</span>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${colors.badge}`}>
                  {statusLabel(cat.status)}
                </span>
                <span className="text-sm font-bold text-gray-700">{cat.score_percentage.toFixed(1)}%</span>
              </div>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2.5">
              <div
                className={`h-2.5 rounded-full transition-all ${colors.bar}`}
                style={{ width: `${cat.score_percentage}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
